import Cookies from 'js-cookie';

import { shareDomain } from '@/settings';

const TokenKey = 'jy_token';
const expire = 24 * 60 * 60 * 1000 * 1000;
const RowId = 'adapter_rowId';
const AmazonRowId = 'adapter_amazon_rowId';
const ReceiveShopId = 'receive_shop_id';
const ShopifyHrefShop = 'shopify_href_shop'
const ShopifyHrefCode = 'shopify_href_code'


export default {
  setToken(token) {
    // 设置cookie有效期
    var inFifteenMinutes = new Date(new Date().getTime() + expire);
    return Cookies.set(TokenKey, token, { domain: shareDomain, expires: inFifteenMinutes, sameSite: 'lax' });

    // // sameSite shopify对接需要配置 勿删
    // return Cookies.set(TokenKey, token, { domain: shareDomain, sameSite: 'lax' });
  },
  getToken() {
    return Cookies.get(TokenKey);
  },
  removeToken() {
    return Cookies.remove(TokenKey, { domain: shareDomain });
  },
  //
  setRowId(rowId) {
    return Cookies.set(RowId, rowId, { domain: shareDomain });
  },
  getRowId() {
    return Cookies.get(RowId);
  },
  removeRowId() {
    return Cookies.remove(RowId, { domain: shareDomain });
  },
  //
  setAmazonRowId(amazonRowId) {
    return Cookies.set(AmazonRowId, amazonRowId, { domain: shareDomain });
  },
  getAmazonRowId() {
    return Cookies.get(AmazonRowId);
  },
  removeAmazonRowId() {
    return Cookies.remove(AmazonRowId, { domain: shareDomain });
  },
  //
  setReceiveShopId(receiveShopId) {
    return Cookies.set(ReceiveShopId, receiveShopId, { domain: shareDomain });
  },
  getReceiveShopId() {
    return Cookies.get(ReceiveShopId);
  },
  removeReceiveShopId() {
    return Cookies.remove(ReceiveShopId, { domain: shareDomain });
  },
  //
  setShopifyHrefShop(shopifyHrefShop) {
    return Cookies.set(ShopifyHrefShop, shopifyHrefShop, { domain: shareDomain });
  },
  getShopifyHrefShop() {
    return Cookies.get(ShopifyHrefShop);
  },
  removeShopifyHrefShop() {
    return Cookies.remove(ShopifyHrefShop, { domain: shareDomain });
  },
  //
  setShopifyHrefCode(shopifyHrefCode) {
    return Cookies.set(ShopifyHrefCode, shopifyHrefCode, { domain: shareDomain });
  },
  getShopifyHrefCode() {
    return Cookies.get(ShopifyHrefCode);
  },
  removeShopifyHrefCode() {
    return Cookies.remove(ShopifyHrefCode, { domain: shareDomain });
  },


};
